import React, { ReactElement, useEffect, useRef } from 'react';

import styled from 'styled-components';

import {
  CalendarIcon,
  PadLockIcon,
  PayAnyonePhone,
  ScissorFeesIcon,
  ThreePeopleIcon,
} from 'chime-ui/components/Icons';
import { Superscript, Text, Title } from 'chime-ui/components/Typography';
import media from 'chime-ui/system/media';

import { useIntersect } from 'hooks/useIntersect';
import { useValuePropsSegmentEvents } from 'hooks/useValuePropsSegmentEvents';

function PayAnyoneValueProps(): ReactElement {
  const containerRef = useRef(null);

  const [setNode, entry] = useIntersect({
    root: null,
    rootMargin: '0px',
    threshold: [0.5, 0.9],
  });

  useEffect(() => {
    setNode(containerRef.current);
  }, [setNode]);

  useValuePropsSegmentEvents(entry, 'PayAnyone Landing Page');

  return (
    <>
      <P2pValuePropsLayout ref={containerRef}>
        <PayAnyonePhoneLayout>
          <PayAnyonePhone />
        </PayAnyonePhoneLayout>
        <P2pTitleLayout>
          <Title size={'small'}>
            Chime lets you cash out instantly fee-free
          </Title>
        </P2pTitleLayout>
        <ListBoxLayout>
          <ListBox>
            <IconLayout>
              <ThreePeopleIcon />
            </IconLayout>
            <CenteredBlockText>
              You can securely send money fee-free to anyone
            </CenteredBlockText>
          </ListBox>
          <ListBox>
            <IconLayout>
              <ScissorFeesIcon />
            </IconLayout>
            <CenteredBlockText>
              No cash-out fees for you or anyone
            </CenteredBlockText>
          </ListBox>
          <ListBox>
            <IconLayout>
              <CalendarIcon />
            </IconLayout>
            <CenteredBlockText>
              <Text>
                Get paid up to 2 days early with direct deposit
                <Superscript>1</Superscript>
              </Text>
            </CenteredBlockText>
          </ListBox>
          <ListBox>
            <IconLayout>
              <PadLockIcon />
            </IconLayout>
            <CenteredBlockText>
              <Text>
                Your funds are FDIC-insured up to $250,000 through our bank
                partners
                <Superscript>2</Superscript>
              </Text>
            </CenteredBlockText>
          </ListBox>
        </ListBoxLayout>
      </P2pValuePropsLayout>
    </>
  );
}

const P2pValuePropsLayout = styled.div`
  margin: 3vh 0 0 0;

  ${media.tinyMobileOnly`
    margin: 10vh 0 0 0;
  `}

  ${media.desktop`
    margin: 2rem 0 0 0;
  `}
`;

const P2pTitleLayout = styled.div`
  margin: 2rem 0 1rem 0;
`;

const ListBoxLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 0.5rem;
`;

const PayAnyonePhoneLayout = styled.div`
  margin-top: 1.5rem;
`;

const ListBox = styled.div`
  display: grid;
  grid-column-gap: 1.5rem;
  align-items: center;
  grid-template-columns: [first] 80px [line2];
`;

const IconLayout = styled.div`
  height: 80px;
  width: 80px;
  max-width: 80px;
  grid-column-start: 1;
`;

const CenteredBlockText = styled.div`
  grid-column-start: 2;
`;

export default PayAnyoneValueProps;
